import { Box, Flex, HStack, Spacer, Td, Tr } from '@chakra-ui/react'
import React from 'react'
import { AiFillEdit, AiFillPrinter } from 'react-icons/ai'
import { BsArrowReturnLeft, BsArrowReturnRight, BsBook, BsBookFill } from 'react-icons/bs'
import { IoIosCheckmarkCircle, IoMdCheckmarkCircle } from 'react-icons/io'
import { typeStore } from '../Utils/Helpers'
import Button from './Button'
import QtyBar from './Qtybar'
import { MdCancel, MdModeEdit } from 'react-icons/md'
import { configuration } from '../Utils/config'
import { isAdminSupervisor, isStore, isSupervisor } from '../Authetication'



export default function TableRow({ staffId, firstName, reference,isDeviceAssignment,staffemail,migrate,StaffChangeQty,qtyControlled, station, inn, out, balance, lastName, update, onEdit, userType, group, status, ChangeStatus, type, storeName, timestamp, approval,
    CategoryName, sn, supervisor, value, minimum, maximum,serialNo, reorder, color = "#fff",qtyLeft, vocab, edit, returnTo, location, district, zone, feeder, createdAt, raised, history, unit, email, print, Approve,Reject,RStore, SStore, productName, sraNo, ticketNo, dept, qtyUnserviceable, qtyServiceable, returnby, productShelfId, qtyinspected, category, viewAtt, store, id, qty, AlertPending, price, onClick, Transfer, supplierName, address, phone, itemNo, dateReceived, invoiceNo, inwardFreight, received }) {





    return (
        <Tr textTransform={"capitalize"} color={color} cursor="pointer" transition={"0.3s"} _hover={{ bg: "#6B9EB9" }}>
            {
                type == "user" && (
                    <>
                        <Td>{staffId}</Td>
                        <Td>{firstName}</Td>
                        <Td >{lastName}</Td>
                        <Td >{userType}</Td>
                        <Td >{group}</Td>
                        <Td fontWeight={"500"} color={status == "active" ? "green" : "red.400"} >{status}</Td>
                        <Td ><Box cursor="pointer" bg={status == "pending" ? "grey" : "teal"} color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={status == "pending" ? AlertPending : ChangeStatus} >{status == "active" ? "Deactivate" : "Activate"} Status</Box></Td>
                    </>
                )
            }
            {
                type == "binCardRow" && (
                    <>
                        <Td>{sn}</Td>
                        <Td>{dateReceived}</Td>
                        <Td >{reference}</Td>
                        <Td >{station}</Td>
                        <Td >{inn}</Td>
                        <Td >{out}</Td>
                        <Td >{balance}</Td>
                       </>
                )
            }
            {
                type == "techUser" && (
                    <>
                        <Td>{sn}</Td>
                        <Td>{email}</Td>
                        <Td >{typeStore(store)}</Td>
                        <Td color={userType == "appadmin" ? "#000FFF" : "yellow"}>{userType}</Td>
                        <Td fontWeight={"500"} color={status == "active" ? "green" : "red.400"} >{status}</Td>
                        <Td ><Box cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} py="8px" px="15px" rounded="8px" onClick={onClick}>Update Status</Box></Td>
                        <Td ><Box cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} py="8px" px="15px" rounded="8px" onClick={update}>Update User</Box></Td>


                    </>
                )
            }
            {
                type == "printSra" && (
                    <>
                        <Td>{vocab}</Td>
                        <Td>{productName}</Td>
                        <Td >{status}</Td>
                        <Td >{qty}</Td>
                        <Td >{price}</Td>
                        <Td >{value}</Td>

                    </>
                )
            }

            {
                type == "store" && (
                    <>
                        <Td>{sn}</Td>
                        <Td>{storeName}</Td>
                    </>
                )
            }

            {
                type == "category" && (
                    <>
                        <Td>{sn}</Td>
                        <Td>{CategoryName}</Td>
                        <Td ><Box cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={onClick}>Update Category</Box></Td>
                    </>
                )
            }


            {
                type == "shelf" && (
                    <>
                        <Td>{sn}</Td>
                        <Td bgColor={isDeviceAssignment && "#03431a"}>{productName}</Td>
                        <Td><QtyBar
                            qty={qty}
                            serviceable={qtyServiceable}
                            unServiceable={qtyUnserviceable}
                        /></Td>

                        <Td>{typeStore(store)}</Td>
                        <Td>{price}</Td>
                        <Td>{category}</Td>
                        <Td ><Box cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={onClick}>Update</Box></Td>
                        <Td ><Box cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={Transfer}>Transfer</Box></Td>
                        <Td>{isDeviceAssignment ? "True": "False"}</Td>
                        <Td ><Box cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={migrate}>Migrate to Device Assignment</Box></Td>
                    </>
                )
            }
            {
                type == "BinShelf" && (
                    <>
                        <Td>{sn}</Td>
                        <Td>{productName}</Td>
                        <Td><QtyBar
                            qty={qty}
                            serviceable={qtyServiceable}
                            unServiceable={qtyUnserviceable}
                        /></Td>

                        <Td>{typeStore(store)}</Td>
                        <Td>{price}</Td>
                        <Td>{minimum}</Td>
                        <Td>{maximum}</Td>
                        <Td>{reorder}</Td>
                        <Td>{category}</Td>
                        {
                            isStore() || isSupervisor() ? (
                        <Td ><Box cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} px="15px" py="8px" rounded="8px" onClick={update}>Update Bin Records</Box></Td>

                            ):(

                        <Td ><Box cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} px="15px" py="8px" rounded="8px" >You don't have access</Box></Td>
                            )

                        }
                        <Td ><Box cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} px="15px" py="8px" rounded="8px" onClick={onClick}>Bin Shelf</Box></Td>
                    </>
                )
            }
            {
                type == "supplier" && (
                    <>
                        <Td>{sn}</Td>
                        <Td>{supplierName}</Td>
                        <Td>{address}</Td>
                        <Td>{phone}</Td>
                        <Td>{status}</Td>
                        <Td ><Box cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={onClick}>View Supplys</Box></Td>
                        <Td ><Box cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={onClick}>Update</Box></Td>
                    </>
                )
            }


            {
                type == "sra" && (
                    <>
                        <Td>{sn}</Td>
                        <Td>{supplierName}</Td>
                        <Td>{itemNo}</Td>
                        <Td>{dateReceived}</Td>
                        <Td>{invoiceNo}</Td>

                        <Td ><Box cursor="pointer" color={"teal"} fontSize={"20px"} onClick={print}><AiFillPrinter /></Box></Td>
                        {
                            status === "AwaitingSupervisor" ? (
                                <Td ><Box cursor="pointer" color={"teal"} onClick={onEdit} fontSize={"20px"} ><MdModeEdit/></Box></Td>

                            ):(
                                <Td ><Box cursor="pointer" color={"#ddd"} fontSize={"15px"} ><MdModeEdit/></Box></Td>

                            )
                        }
                        <Td ><Box cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={onClick}>View more</Box></Td>
                    </>
                )
            }
            {
                type == "sraApproval" && (
                    <>
                        <Td>{sn}</Td>
                        <Td>{supplierName}</Td>
                        <Td>{raised}</Td>
                        <Td>{dateReceived}</Td>
                        <Td>{invoiceNo}</Td>
                        <Td ><Box cursor="pointer" bg="green" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={Approve}>Approve</Box></Td>
                        <Td ><Box cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={onClick}>View more</Box></Td>
                    </>
                )
            }
            {
                type == "sraApprovalT" && (
                    <>
                        <Td>{sn}</Td>
                        <Td>{supplierName}</Td>
                        <Td>{raised}</Td>
                        <Td>{dateReceived}</Td>
                        <Td>{invoiceNo}</Td>
                        <Td>{status}</Td>
                        <Td >
                        {
                            status === "PendingI&QA" &&
                            <Box cursor="pointer" bg="red" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={Approve}>Reject</Box>

                        }
                        </Td>
                        <Td ><Box cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={onClick}>View more</Box></Td>
                    </>
                )
            }
            {
                type == "sraReport" && (
                    <>
                        <Td>{sn}</Td>
                        <Td>{sraNo}</Td>
                        <Td>{itemNo}</Td>
                        <Td>{dateReceived}</Td>
                        <Td>{invoiceNo}</Td>
                        <Td>{raised}</Td>

                    </>
                )
            }
            {
                type == "transferReport" && (
                    <>
                        <Td>{sn}</Td>
                        <Td>{email}</Td>
                        <Td>{productName}</Td>
                        <Td>{qty}</Td>
                        <Td>{typeStore(RStore)}</Td>
                        <Td>{typeStore(SStore)}</Td>
                        <Td>{price}</Td>

                    </>
                )
            }
            {
                type == "shelfReport" && (
                    <>
                        <Td>{sn}</Td>
                        <Td>{productName}</Td>
                        <Td>{productShelfId}</Td>
                        <Td><QtyBar
                            qty={qty}
                            serviceable={qtyServiceable}
                            unServiceable={qtyUnserviceable}
                        /></Td>
                        <Td>{unit}</Td>

                    </>
                )
            }
            {
                type == "scnReport" && (
                    <>
                        <Td>{sn}</Td>
                        <Td>{productName}</Td>
                        <Td>{qty}</Td>
                        <Td>{qtyinspected}</Td>
                        <Td>{qtyServiceable}</Td>
                        <Td>{qtyUnserviceable}</Td>
                        <Td>{dateReceived}</Td>

                        <Td>{dept}</Td>

                    </>
                )
            }
            {
                type == "requestReport" && (
                    <>
                        <Td>{sn}</Td>
                        <Td>{ticketNo}</Td>
                        <Td>{productName}</Td>
                        <Td>{staffId}</Td>
                        <Td>{supervisor}</Td>
                        <Td>{status}</Td>
                        <Td>{dateReceived}</Td>



                    </>
                )
            }


            {
                type == "pendingSra" && (
                    <>
                        <Td>{sn}</Td>
                        <Td>{productName}</Td>
                        <Td>{productShelfId}</Td>

                        <Td>{itemNo}</Td>

                        <Td>{dateReceived}</Td>
                        <Td>{qtyinspected}</Td>
                        <Td ><Box cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={viewAtt}>View Attachment</Box></Td>
                        <Td ><Box cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={onClick}>Inspect</Box></Td>
                    </>
                )
            }

            {
                type == "inspectedSra" && (
                    <>
                        <Td>{sn}</Td>
                        <Td>{productName}</Td>
                        <Td>{productShelfId}</Td>
                        <Td>{typeStore(store)}</Td>
                        <Td>{qtyinspected}</Td>
                        <Td>{dateReceived}</Td>

                        <Td ><Box cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={viewAtt}>View Attachment</Box></Td>
                        <Td ><Box cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={onClick}>Take Action</Box></Td>
                    </>
                )
            }
            {
                type == "pickUp" && (
                    <>
                        <Td fontSize={"12px"}>{sn}</Td>
                        <Td fontSize={"12px"}>{ticketNo}</Td>
                        <Td fontSize={"12px"}>{productName}</Td>
                        <Td fontSize={"12px"}>{staffId}</Td>
                        <Td fontSize={"12px"}>{dateReceived}</Td>
                        <Td fontSize={"12px"}>{status}</Td>
                        <Td>
                            <HStack>
                                <Box>{qty}</Box>
                                {
                                    status === "AwaitingSupervisor" ||  status === "Awaiting Confirmation" && (

                                      <Box pl="10px" color={"teal"} fontSize={"20px"} onClick={onEdit}><AiFillEdit /></Box>
                                    )
                                }

                            </HStack>
                        </Td>
                        <Td ><Box cursor="pointer" color={"teal"} fontSize={"20px"} onClick={print}><AiFillPrinter /></Box></Td>
                        {
                            status === "Collected" ? (
                                <Td>Collected</Td>

                            ) : status === "AwaitingSupervisor" ? (
                                <Td ><Box fontSize={"12px"} cursor="pointer" bg="orange" color="#fff" w='auto' textAlign={"center"} p="8px 4px" rounded="8px" >Awaiting Supervisor</Box></Td>

                            ) : status === "Awaiting Confirmation" ?
                                (
                                    <Td ><Box fontSize={"12px"} cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} p="8px 4px" rounded="8px" onClick={onClick}>Confirm</Box></Td>

                                ) : (
                                    <Td ><Box fontSize={"12px"} cursor="pointer" bg="red" color="#fff" w='auto' textAlign={"center"} p="8px 4px" rounded="8px" >Rejected by supervisor</Box></Td>

                                )
                        }
                    </>
                )
            }
            {
                type == "device assignment request" && (
                    <>
                        <Td fontSize={"12px"}>{sn}</Td>
                        <Td fontSize={"12px"}>{serialNo}</Td>
                        <Td fontSize={"12px"}>{ticketNo}</Td>
                        <Td fontSize={"12px"}>{productName}</Td>
                        <Td>{qty}</Td>
                        <Td>{typeStore(store)}</Td>
                        <Td>{staffemail}</Td>
                        <Td>{dept}</Td>
                        <Td fontSize={"12px"}>{isDeviceAssignment === true ? "True": "false"}</Td>
                        <Td fontSize={"12px"}>{dateReceived}</Td>
                      
                      
                       
                    </>
                )
            }
            {
                type == "device assignment procurement" && (
                    <>
                        <Td fontSize={"12px"}>{sn}</Td>
                        <Td fontSize={"12px"}>{sraNo}</Td>
                        <Td fontSize={"12px"}>{isDeviceAssignment === true ? "True": "false"}</Td>
                        <Td fontSize={"12px"}>{dateReceived}</Td>
                        <Td bg={status === "Completed" ? "green": "" } textAlign={"center"} rounded={"13px"} fontSize={"12px"}>{status}</Td>
                        <Td ><Box cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={onClick}>View More</Box></Td>
                        <Td ><Box cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={update}>Update</Box></Td>
                       
                      
                       
                    </>
                )
            }
            {
                type == "device assignment RTS" && (
                    <>
                        <Td fontSize={"12px"}>{sn}</Td>
                        <Td fontSize={"12px"}>{serialNo}</Td>
                        <Td fontSize={"12px"}>{productName}</Td>
                        <Td fontSize={"12px"}>{returnby}</Td>
                        <Td fontSize={"12px"}>{dept}</Td>
                        <Td fontSize={"12px"}>{typeStore(store)}</Td>
                        <Td>{qty}</Td>
                        <Td>{reference}</Td>    
                        <Td fontSize={"12px"}>{isDeviceAssignment === true ? "True": "false"}</Td>
                  
                       
                    </>
                )
            }
            {
                type == "pickUpGroup" && (
                    <>
                        <Td>{sn}</Td>
                        <Td>{ticketNo}</Td>
                        <Td>
                            {typeStore(store)}
                        </Td>
                        <Td>{staffId}</Td>
                        <Td>{email}</Td>
                        <Td>{dept}</Td>
                        <Td>{dateReceived}</Td>
                        <Td>{timestamp}</Td>
                        <Td>{approval}</Td>
                        <Td ><Box cursor="pointer" color={"teal"} fontSize={"20px"} onClick={print}><AiFillPrinter /></Box></Td>
                        <Td ><Box cursor="pointer" color={"teal"} fontSize={"20px"} onClick={history}><BsBook /></Box></Td>
                        <Td ><Box cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={onClick}>Proceed</Box></Td>

                    </>
                )
            }
            {
                type == "pickUpGroupModal" && (
                    <>
                        <Td>{sn}</Td>
                        <Td>{productName}</Td>
                        <Td>
                        <HStack>
                                <Box>{qty}</Box>

                                {
                                    status === "AwaitingSupervisor" ||  status === "Awaiting Confirmation" && (

                                      <Box pl="10px" color={"teal"} fontSize={"20px"} onClick={onEdit}><AiFillEdit /></Box>
                                    )
                                }
                            </HStack>
                        </Td>
                        <Td>{qtyLeft}</Td>
                        <Td>{zone}</Td>
                        <Td>{location}</Td>
                        <Td>{district}</Td>
                        <Td>{feeder}</Td>

                       {status === "Awaiting Confirmation"?<Td>Awaiting Pickup</Td>:<Td>{status}</Td>}

                        {
                            status === "Collected" ? (
                                <Td>Collected</Td>

                            ) : status === "AwaitingSupervisor" ? (
                                <Td ><Box cursor="pointer" bg="orange" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" >Awaiting Supervisor</Box></Td>

                            ) : status === "Awaiting Confirmation" ?
                                (
                                    <Td >
                                        <Flex justifyContent={"space-evenly"}>
                                            <Box cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={returnTo}><BsArrowReturnLeft /></Box>
                                            <Box cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={onClick}><BsArrowReturnRight /></Box>
                                        </Flex>
                                    </Td>

                                ) : (
                                    <Td ><Box cursor="pointer" bg="red" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" >Rejected by supervisor</Box></Td>

                                )
                        }

                    </>
                )
            }
            {
                type == "historyRequest" && (
                    <>
                        <Td>{sn}</Td>
                        <Td>{productName}</Td>
                        <Td>{qty}</Td>
                        <Td>{dateReceived}</Td>
                        <Td>{status}</Td>


                    </>
                )
            }
            {
                type == "trackProduct" && (
                    <>
                        <Td>{sn}</Td>
                        <Td>{productName}</Td>
                        <Td>{productShelfId}</Td>

                        <Td>{itemNo}</Td>

                        <Td >{dateReceived}</Td>
                        <Td color={status === "PendingI&QA" ? "orange" : status === "Inspected" ? "yellow" : "green"}>{status}</Td>


                        <Td ><Box cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={onClick}>Read More</Box></Td>
                    </>
                )
            }

            {
                type == "returnToStore" && (
                    <>
                        <Td>{sn}</Td>
                        <Td>{productName}</Td>
                        <Td>{price}</Td>
                        <Td >{qty}</Td>
                        <Td >{dept}</Td>
                        <Td color={status === "PendingI&QA" ? "orange" : status === "Inspected" ? "yellow" : "green"}>{status}</Td>
                        <Td ><Box cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={onClick}>Read More</Box></Td>

                    </>
                )
            }
            {
                type == "expectedReturnToStore" && (
                    <>
                        <Td>{sn}</Td>
                        <Td >{ticketNo}</Td>
                        <Td>{productName}</Td>
                        <Td>{staffId}</Td>
                        <Td>{qty}</Td>
                        <Td>{qtyinspected}</Td>
                        <Td color={status === true ? "green" : "yellow"}>{status === true ? "Returned" : "Not Returned"}</Td>
                        <Td >{dateReceived}</Td>
                        <Td ><Box cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={onClick}>Return to store</Box></Td>

                    </>
                )
            }
            {
                type == "scnApproval" && (
                    <>
                        <Td>{sn}</Td>
                        <Td>{productName}</Td>
                        <Td>{price}</Td>
                        <Td >{qty}</Td>
                        <Td >{dept}</Td>
                        <Td ><Box cursor="pointer" bg="green" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={Approve}>Approve</Box></Td>
                        <Td ><Box cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={onClick}>Read More</Box></Td>

                    </>
                )
            }
            {
                type == "scnApprovalT" && (
                    <>
                        <Td>{sn}</Td>
                        <Td>{productName}</Td>
                        <Td>{price}</Td>
                        <Td >{qty}</Td>
                        <Td >{dept}</Td>
                        <Td >{status}</Td>
                        <Td >
                        {
                            status === "PendingI&QA" &&
                        <Box cursor="pointer" bg="red" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={Approve}>Reject</Box>
                        }
                        </Td>
                        <Td ><Box cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={onClick}>Read More</Box></Td>

                    </>
                )
            }
            {
                type == "RequestApproval" && (
                    <>
                        <Td>{sn}</Td>
                        <Td>{ticketNo}</Td>
                        <Td>{email}</Td>
                        <Td>{dept}</Td>
                        <Td>{productName}</Td>
                        <Td>
                            <HStack>
                                <Box>{qty}</Box>

                                <Box pl="10px" color={"teal"} fontSize={"20px"} onClick={onClick}><AiFillEdit /></Box>
                            </HStack>
                        </Td>
                        <Td >{dateReceived}</Td>
                        <Td ><Box cursor="pointer" color={"teal"} fontSize={"20px"} onClick={history}><BsBook /></Box></Td>
                       
                        <Td ><Flex justifyContent={"space-between"}>
                            
                                

                                    <Box cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={history}><BsBook/></Box>
                                    <Box cursor="pointer" bg="green" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={Approve}><IoIosCheckmarkCircle/></Box>
                                
                            
                        </Flex></Td>

                    </>
                )
            }
            {
                type == "RequestApprovalT" && (
                    <>
                        <Td>{sn}</Td>
                        <Td>{ticketNo}</Td>
                        <Td>{email}</Td>
                        <Td>{productName}</Td>
                        <Td>
                        {
                            status === configuration.technicalsupevisorqtypermission && (
                                <HStack>
                                <Box>{qty}</Box>

                                <Box pl="10px" color={"teal"} fontSize={"20px"} onClick={onClick}><AiFillEdit /></Box>
                            </HStack>
                            )
                        }
                            
                        </Td>
                        <Td >{dateReceived}</Td>
                        <Td >{typeStore(store)}</Td>
                        <Td >{location}</Td>
                        <Td >{district}</Td>
                        <Td >{zone}</Td>
                        <Td >{feeder}</Td>
                        <Td >{status}</Td>
                        <Td >{createdAt}</Td>
                        <Td >{approval}</Td>
                        <Td ><Flex justifyContent={"center"}>
                            {
                                status === "Awaiting Confirmation" && (

                                    <Box cursor="pointer" bg="red" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={Approve}><MdCancel /></Box>
                                )
                            }
                        </Flex></Td>

                    </>
                )
            }
            {
                type == "TransferApproval" && (
                    <>
                        <Td>{sn}</Td>
                        <Td>{productName}</Td>
                        <Td>{productShelfId}</Td>
                        <Td >{typeStore(store)}</Td>
                        <Td >{typeStore(storeName)}</Td>
                        <Td>
                            <HStack>
                                <Box>{qty}</Box>

                                <Box pl="10px" color={"teal"} fontSize={"20px"} onClick={onClick}><AiFillEdit /></Box>
                            </HStack>
                        </Td>
                        <Td>{email}</Td>

                       {
                       // <Td><Box cursor="pointer" bg="green" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={Approve}>Approve</Box></Td>
                        }
                        <Td><Box cursor="pointer" bg="green" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" >Approve</Box></Td>
                      


                    </>
                )
            }
            {
                type == "TransferApprovalT" && (
                    <>
                        <Td>{sn}</Td>
                        <Td>{productName}</Td>
                        <Td>{productShelfId}</Td>
                        <Td >{typeStore(store)}</Td>
                        <Td >{typeStore(storeName)}</Td>
                        <Td>
                            <HStack>
                                <Box>{qty}</Box>


                                {status == "AwaitingSupervisor" && <Box pl="10px" color={"teal"} fontSize={"20px"} onClick={onClick}><AiFillEdit /></Box>}

                            </HStack>
                        </Td>
                        <Td>{email}</Td>
                        <Td>{status}</Td>

                        <Td>{status == "AwaitingSupervisor" && <Box cursor="pointer" bg="red" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={Reject}>Reject</Box>}</Td>
                        <Td>{status == "AwaitingSupervisor" && <Box cursor="pointer" bg="green" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={Approve}>Approve</Box>}</Td>


                    </>
                )
            }
            {
                type == "Transfer" && (
                    <>
                        <Td>{sn}</Td>
                        <Td>{productName}</Td>
                        <Td>{productShelfId}</Td>
                        <Td >{typeStore(store)}</Td>
                        <Td >{typeStore(storeName)}</Td>
                        <Td>{qty}</Td>
                        {
                            status === "Confirmed" ? (
                                <Td>{status}</Td>

                            ) : status === "AwaitingSupervisor" ? (
                                <Td ><Box cursor="pointer" bg="orange" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" >{status}</Box></Td>

                            ) : status === "Awaiting Confirmation" ?
                                (
                                    <Td ><Box cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" >{status}</Box></Td>

                                ) : (
                                    <Td ><Box cursor="pointer" bg="red" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" >{status}</Box></Td>

                                )
                        }

                        <Td>{email}</Td>
                    </>
                )
            }


            {
                type == "pendingScn" && (
                    <>
                        <Td>{sn}</Td>
                        <Td>{productName}</Td>
                        <Td>{price}</Td>
                        <Td >{qty}</Td>
                        <Td >{dept}</Td>
                        <Td >{returnby}</Td>


                        <Td ><Box cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={onClick}>Inspect</Box></Td>

                    </>
                )
            }

        </Tr>
    )

}
